import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

interface CreateAccountFormProps {
  onSubmit: () => void;
  onCancel: () => void;
  isLoading: boolean;
}

export const CreateAccountForm = ({
  onSubmit,
  onCancel,
  isLoading,
}: CreateAccountFormProps) => {
  const { t } = useTranslation();
  
  return (
    <div className="flex gap-2">
      <Button onClick={onSubmit} disabled={isLoading}>
        {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
        {t("accounts.create")}
      </Button>
      <Button variant="ghost" onClick={onCancel}>
        {t("common.cancel")}
      </Button>
    </div>
  );
};
